import { render } from "./404.vue?vue&type=template&id=77f29a3a&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=77f29a3a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f29a3a"]])

export default __exports__